import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(HttpApi)
    .init({
        // debug: true,
        returnNull: false,
        lng: localStorage.getItem("i18nextLng") ?? "en",
        fallbackLng: "en",
        load: "currentOnly",
        lowerCaseLng: true,
        ns: ["translation", "missing"],
        defaultNS: "translation",
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `${process.env.REACT_APP_BASE_URL}locales/{{lng}}/{{ns}}`,
            addPath: `${process.env.REACT_APP_BASE_URL}locales/add/{{lng}}/{{ns}}`,
            crossDomain: true,
            reloadInterval: false,
            allowMultiLoading: true,
        },
        partialBundledLanguages: true,
        saveMissing: false,
    });

export default i18n;